import { Tooltip as Bs5Tooltip } from 'react-bootstrap5';

export default Bs5Tooltip;
